import { createSelector } from 'reselect';
import { trackersStore } from './selectors';

export const makeGetHasBeenFirstFetched = () =>
    createSelector(
        trackersStore,
        (store) => store.firstFetch,
    );
